import { useState } from "react";
import styled from "styled-components";
import {
    // Box,
    Flex,
    HelpIcon,
    LinkExternal,
    Text,
    TimerIcon,
    useMatchBreakpoints,
} from "@pancakeswap/uikit";
import { AccordionDetails, AccordionSummary } from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from '@mui/material'
import FarmNameCell from "./Cells/FarmNameCell";
import AutoEarningsCell from "views/Pools/components/PoolsTable/Cells/AutoEarningsCell";
import AprCell from "views/Pools/components/PoolsTable/Cells/AprCell";
import TotalStakedCell from "views/Pools/components/PoolsTable/Cells/TotalStakedCell";
import ActionPanel from "views/Pools/components/PoolsTable/ActionPanel/ActionPanel";
import AprRow from "views/Pools/components/PoolCard/AprRow";
import FarmActionPanel from './FarmActionPanel/FarmActionPanel'
import FarmAprCell from "./Cells/FarmAprCell";

interface FarmRowProps {
    pool: any;
    index: any;
    account: string;
    userDataLoaded: boolean;
}

export enum VaultKey {
    CakeVault = "cakeVault",
    IfoPool = "ifoPool",
}

const StyledRow = styled.div`
  background-color: transparent;
  display: flex;
  cursor: pointer;
`;

const InfoSection = styled(Box)`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  padding: 8px 8px;
  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0;
    flex-basis: 230px;
  }
`;

const RequirementSection = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${({ theme }) => theme.mediaQueries.lg} {
    display: inline-block;

    > div {
      display: inline;
      margin-right: 4px;
    }
  }
`;

const AutoTag = styled.div`
  align-items: center;
  border-radius: 16px;
  display: inline-flex;
  font-weight: 400;
  white-space: nowrap;
  height: 28px;
  padding: 0 8px;
  font-size: 14px;
  color: #31d0aa;
  background: #faf9fa;
  border: 2px solid #31d0aa;
`;
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px `,
}));

const FarmRow: React.FC<FarmRowProps> = ({ pool, index, account, userDataLoaded }) => {
    const { isXs, isSm, isMd, isLg, isXl, isXxl, isTablet, isDesktop } =
        useMatchBreakpoints();
    const isLargerScreen = isLg || isXl || isXxl;
    const isXLargerScreen = isXl || isXxl;
    const [expanded, setExpanded] = useState(false);
    const shouldRenderActionPanel = true;

    const toggleExpanded = () => {
        setExpanded((prev) => !prev);
    };

    return (
        <>
            <Box sx={{
                // background: '#00202F'
            }}>
                <Accordion
                    sx={{
                        backgroundColor: '#00202F',
                        borderRadius: "30px",
                        // borderBottomLeftRadius: "20px",
                        // borderBottomRightRadius: "20px",
                        // borderTopLeftRadius: "30px",
                        // borderTopRightRadius: "30px",
                    }}
                >
                    <AccordionSummary sx={{
                        minHeight: "80px",
                        height: "100%",
                        ml: 0,
                        width: "100%",
                    }}
                        expandIcon={<ExpandMoreIcon sx={{ color: "#00FED9" }} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Box sx={{ display: { xs: 'block', sm: 'flex', md: 'flex', lg: 'flex', xl: 'flex' }, flex: '1 0 200px', pt: { xs: '15px', sm: '0px', md: '0px', lg: '0px', xl: '0px' } }}>
                            <FarmNameCell pool={pool} />
                            <Box sx={{ display: 'flex', flex: 'auto', justifyContent: 'space-between', pt: { xs: '25px', sm: '0px', md: '0px', lg: '0px', xl: '0px' } }}>
                                <Box>
                                    <AutoEarningsCell price={0} pool={pool} account={account} />
                                </Box>
                                <Box sx={{ display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'flex' }, alignItems: { xs: 'baseline', sm: 'center', md: 'center', lg: 'center' } }}>
                                    <FarmAprCell pool={pool} index={index} />
                                </Box>
                            </Box>
                        </Box>

                        {/* <Box sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block' } }}>
                            <AprRow pool={pool} index={index} />
                        </Box> */}
                        <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'flex' }, alignItems: 'center' }}>
                            <TotalStakedCell pool={pool} />
                        </Box>
                        <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }}>
                            {/* <EndBlocks pool={pool} /> */}
                        </Box>
                        {/* {isDesktop && <EndsInCell pool={pool} />} */}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, }}>
                        <FarmActionPanel
                            account={account}
                            pool={pool}
                            index={index}
                            expanded={expanded}
                            breakpoints={{ isXs, isSm, isMd, isLg, isXl, isXxl }}
                        />
                    </AccordionDetails>
                </Accordion>
            </Box>
        </>
    );
};

export default FarmRow;
